import { jsx } from "react/jsx-runtime";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { validateTidalLicense } from "../../base/index.js";
function CloudUpload(props) {
  return /* @__PURE__ */ jsx(
    CloudUploadIcon,
    {
      "data-testid": "CloudUpload",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CloudUpload",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
CloudUpload.tidalIconMeta = {
  categories: "fileActions",
  name: "CloudUpload"
};
validateTidalLicense();
export {
  CloudUpload
};
//# sourceMappingURL=CloudUpload.js.map
